import { render, staticRenderFns } from "./depreciationManage.vue?vue&type=template&id=99b49618&scoped=true"
import script from "./depreciationManage.vue?vue&type=script&lang=js"
export * from "./depreciationManage.vue?vue&type=script&lang=js"
import style0 from "./depreciationManage.vue?vue&type=style&index=0&id=99b49618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b49618",
  null
  
)

export default component.exports